import { lazy } from 'react';

export const newpatient = lazy(() => import('./newpatient'));
export const preauth = lazy(() => import('./preauth'));
export const caseref = lazy(() => import('./caseref'));
